import { CheckIcon } from '@chakra-ui/icons'
import { Avatar, HStack, MenuItem, Text } from '@chakra-ui/react'
import { Token, Width } from 'types/chakra'
import { IAsyncSelectOptionWithIcon } from 'interfaces/common'
import IconBuilder from 'pages/IconBuilderPage/components/IconBuilder'

interface IDropdownSelectionProps {
  item: IAsyncSelectOptionWithIcon<number>
  onClick: () => void
  isSelected?: boolean
  height?: Token<Width | number, 'sizes'>
  minWidth?: Token<Width | number, 'sizes'>
  maxWidth?: Token<Width | number, 'sizes'>
}

const DropdownSelection = (props: IDropdownSelectionProps) => {
  const { item, onClick, isSelected, minWidth, maxWidth } = props

  return (
    <MenuItem
      padding="6px 12px"
      minWidth={minWidth}
      maxWidth={maxWidth}
      onClick={onClick}
      className="dropdown-selection"
      background={isSelected ? 'primary.100' : 'white'}
      _hover={{ background: 'primary.100' }}
      borderWidth="0"
      outline="none"
      height="44px"
      color="gray.700"
      fontSize={{ base: 'md', lg: 'sm' }}
      justifyContent={{ base: 'center', md: 'flex-start' }}
    >
      <HStack width="full" spacing={6}>
        <HStack width="full">
          {item?.icon && <IconBuilder icon={item?.icon} size={32} isActive />}
          {(item?.image || item?.image === '') && <Avatar size="xs" name={item.label} src={item.image} />}
          <Text>{item?.label ?? ''}</Text>
        </HStack>
        <CheckIcon display={isSelected ? 'block' : 'none'} color="primary.500" />
      </HStack>
    </MenuItem>
  )
}

export default DropdownSelection
